var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(-1104 -542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_001-facebook",
    "data-name": "001-facebook",
    d: "M21.3,0H1.243A1.244,1.244,0,0,0,0,1.245V21.3a1.244,1.244,0,0,0,1.245,1.243h10.8V13.828H9.116V10.415h2.928V7.9c0-2.913,1.778-4.5,4.376-4.5a24.093,24.093,0,0,1,2.626.134V6.584H17.254c-1.414,0-1.687.672-1.687,1.658v2.174h3.38l-.44,3.413H15.567v8.719H21.3A1.244,1.244,0,0,0,22.547,21.3h0V1.243A1.244,1.244,0,0,0,21.3,0Zm0,0",
    transform: "translate(1115 553)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a7ccc55bc163c6323e4b1d3a4a2ca4b9.svg";
export { ForwardRef as ReactComponent };